module.exports = __webpack_public_path__ + "components/choice/static/check-17afc3b93a6075b1cc6b5f507df3475e.svg";